import Phaser from 'phaser'
import { audioManager } from '../audio/AudioManager'

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Boot' })
  }

  preload() {
    // All assets are drawn programmatically – nothing to load.
  }

  create() {
    // Resume AudioContext on first user gesture (browser policy requirement).
    this.input.once('pointerdown', () => audioManager.resume())
    const nextScene = localStorage.getItem('henry_start_scene')
    if (nextScene) {
      localStorage.removeItem('henry_start_scene')
      this.scene.start(nextScene)
      return
    }

    this.scene.start('Menu')
  }
}
